import PropTypes from 'prop-types';
import { useContext } from 'react';
import classNames from 'clsx';
import interpolateComponents from 'interpolate-components';
import {
  SUBSCRIBE_DEFAULT_PRODUCT_DETAILS,
  SUBSCRIBE_MONTHLY_PRODUCT_DETAILS,
  SUBSCRIBE_NO_TRIAL_PRODUCT_DETAILS,
  SUBSCRIBE_MONTHLY_PRODUCT_DETAILS_SETUPFEE,
} from 'src/common/constants/localizations/subscription';
import { getMsForDays } from '../utils/subscriptionProductDetails';
import calculateDaysInMonths from '../../utils/calculateDaysInMonths';
import getOverrideOrDefaultResourceKey from '../../utils/getOverrideOrDefaultResourceKey';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import css from './payment.module.scss';

const expDateFormat = { year: 'numeric', month: 'short', day: 'numeric' };

const getExpectedString = (product, getLocalizedText, location, locale) => {
  const { isMonthlyTrial, hasTrial, price, freeTrialLength, setupPrice } =
    product;

  // get number of days from the product
  const numDays = isMonthlyTrial
    ? calculateDaysInMonths(freeTrialLength)
    : freeTrialLength;

  // calculate new trail exp date based on current date and free trial length
  const trialExpDate = new Date(new Date().valueOf() + getMsForDays(numDays));

  // display either monthly or days for free trial
  let productDetailsLocalizationKey = isMonthlyTrial
    ? SUBSCRIBE_MONTHLY_PRODUCT_DETAILS
    : SUBSCRIBE_DEFAULT_PRODUCT_DETAILS;

  productDetailsLocalizationKey = hasTrial
    ? productDetailsLocalizationKey
    : SUBSCRIBE_NO_TRIAL_PRODUCT_DETAILS;

  if (setupPrice) {
    productDetailsLocalizationKey = SUBSCRIBE_MONTHLY_PRODUCT_DETAILS_SETUPFEE;
  }

  return interpolateComponents({
    mixedString: getLocalizedText(
      getOverrideOrDefaultResourceKey(
        getLocalizedText,
        location,
        productDetailsLocalizationKey,
      ),
    ),
    components: {
      freeTrialLength: (
        <span data-testid="freeTrialLength">{freeTrialLength}</span>
      ),
      trialExpDate: (
        <span data-testid="trialExpDate">
          {trialExpDate.toLocaleString(locale, expDateFormat)}
        </span>
      ),
      price: <span data-testid="priceOfSelectedProduct">{price}</span>,
    },
  });
};

const RadioButtonDetails = ({ product }) => {
  const { getLocalizedText, locale } = useContext(
    LocationAndLocalizationContext,
  );

  return (
    <div className={classNames('row', css.productDescription)}>
      <div data-testid="productsInfo" className="col-xs-12">
        {getExpectedString(product, getLocalizedText, location, locale)}
      </div>
    </div>
  );
};

RadioButtonDetails.propTypes = {
  product: PropTypes.object.isRequired,
};

export default RadioButtonDetails;
